// ES6 Modules
import Swal from 'sweetalert2';
import {result} from "lodash/object";

const customSweetAlert = Swal.mixin({
    customClass: {
        confirmButton: 'mx-2 px-5 py-2.5 font-bold text-white bg-phosfor-500 hover:bg-mustard-500 rounded-lg',
        cancelButton:  'mx-2 px-5 py-2.5 font-bold text-white bg-sunburn-500 hover:bg-sunburn-800 rounded-lg',
    },
    buttonsStyling: false
})

/**
 * The sweetConfig should looks like this folowing structure :
 * var sweetConfig = {
 *             'delete-user': {                     => the name of the config variable
 *                 'mode': 'confirm',               => Action to be done
 *                 'title': '',
 *                 'button': {
 *                     'text': ''
 *                 },
 *                 'content': {
 *                   'text': ''
 *                 },
 *                 'actionDone': {
 *                     'text': ''
 *                 },
 *                 'routes' : {
 *                     'action': {
 *                         'confirm':  '{{ route('example.postgate', ['action' => 'confirmDestroy', 'id' => '#:ID:#']) }}',
 *                         'delete':   '{{ route('example.postgate', ['action' => 'destroy', 'id' => '#:ID:#']) }}'
 *                     },
 *                 },
 *             },
 *         }
 *
 * Each controller should have a confirmDestroy (AJAX) method which return the name (or the title) of the resource to be destroy
 * And the destroy method have to return a json response who look like :
 *
 * return response()->json([
 *             'data'      => 'The (name of the thing you have been destroy) has been deleted !!',
 *             'action'    => 'done'
 *
 *         ]);
 * */

let config = {};
let data = {};
let err = {};
let action;
let debug = false;


/**
 * Initialise data structures required for sweet alert handling based on the data provided by the calling view
 *
 * @param sweetConfig    // Elements holding / providing the data           (configured in blade view)
 * @param formDebug      // Activate debug mode                             (configured in blade view)
 * */
window.initSweetAlert = function (sweetConfig, sweetDebug = false)
{
    config  = sweetConfig;
    debug   = sweetDebug;
}

/**
 * Display sweet alert in either (fetches data from server)
 * @param actionToDo            // Action to proceed
 * @param configId || null      // Position of modalID in config keys array
 * @param id  || null           // ID of record to fetch
 * @param error  || null        // The error from the post form data for this resource (if there are one, ofc)
 */
window.showSweetAlert = async function (actionToDo, configId = null,  id = null, error = null)
{
    action  = actionToDo;
    err     = error;

    if (debug) {
        console.log('Action done : ' + action);
        console.log('Error : ' , err);
    }

    if (err) {
        if (debug) { console.log('Error to be resolved :', err); }

        showSweetError(err);
    }
    // Whenever confirmation is needed
    else if (id && configId) {
        await proceedAction(configId, id);
    }
    // When a post form request is done an successful (As at the creation or update resource)
    else {
        action = 'done';

        if (debug) {
            console.log('Action done : ' + action);
            console.log('Error : ' , err);
        }

        showSweetConfirmation();
    }
}


/////////////////////////////////////////////////////////////////////////////////////////////////////////
// PRIVATE FUNCTION
/////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Fetch and feed the data (fetches data from server) and update Action
 * @param configId       // Sweet alert name config
 * @param id            // ID of record to fetch
 */
async function proceedAction(configId, id)
{
    if (!id) { return Promise.resolve({ data: {} }); }

    if (debug) { console.log('Action in proceed : ' + action); }

    try {
        let res;
        switch (true) {
            case action === 'confirm':
                try {
                    res = await axios.get(config[configId]['routes']['action'][action].replace(/#:ID:#/, id));
                    if (debug) { console.log("Data fetched in confirm action : ", res); }
                    action = res.data.action;
                    data = res.data.data;
                    if(res.status === 200) { showSweetConfirmation(configId, id); } else { showSweetError({ 'message' : 'An error !', 'status': res.status }); }
                    break;
                } catch (error) {
                    showSweetError(error);
                    break;
                }

            case action === 'delete':
                try {
                    res = await axios.get(config[configId]['routes']['action'][action].replace(/#:ID:#/, id));
                    if (debug) { console.log("Data fetched in delete action : ", res); }
                    action = res.data.action;
                    if(res.status === 200) { showSweetConfirmation(configId, id, res.data); } else { showSweetError({ 'message' : 'An error !', 'status': res.status }); }
                    break;
                } catch (error) {
                    showSweetError(error);
                    break;
                }

            case action === 'send':
                try {
                    res = await axios.get(config[configId]['routes']['action'][action].replace(/#:ID:#/, id));
                    if (debug) { console.log("Data fetched in send action : ", res); }
                    action = res.data.action;
                    if(res.status === 200) { showSweetConfirmation(configId, id, res.data); } else { showSweetError({ 'message' : 'An error !', 'status': res.status }); }
                    break;
                } catch (error) {
                    showSweetError(error);
                    break;
                }

            case action === 'desactive':
                try {
                    res = await axios.get(config[configId]['routes']['action'][action].replace(/#:ID:#/, id));
                    action = res.data.action;
                    if(res.status === 200) { showSweetConfirmation(configId, id, res.data); } else { showSweetError({ 'message' : 'An error !', 'status': res.status }); }
                    break;
                } catch (error) {
                    showSweetError(error);
                    break;
                }

            case action === 'reactive':
                try {
                    res = await axios.get(config[configId]['routes']['action'][action].replace(/#:ID:#/, id));
                    action = res.data.action;

                    if (res.status === 200) { showSweetConfirmation(configId, id, res.data); }
                    else                    { showSweetError({ 'message' : 'An error !', 'status': res.status }); }

                } catch (error) {
                    showSweetError(error);
                }
                break;

            case action === 'anonymise':
                try {
                    res = await axios.get(config[configId]['routes']['action'][action].replace(/#:ID:#/, id));
                    action = res.data.action;
                    if(res.status === 200) { showSweetConfirmation(configId, id, res.data); } else { showSweetError({ 'message' : 'An error !', 'status': res.status }); }
                    break;
                } catch (error) {
                    showSweetError({'message': error });
                    break;
                }

            case action === 'impersonate':
                try {
                    res = await axios.get(config[configId]['routes']['action'][action].replace(/#:ID:#/, id));
                    action = res.data.action;
                    if(res.status === 200) { showSweetConfirmation(configId, id, res.data); } else { showSweetError({ 'message' : 'An error !', 'status': res.status }); }
                    break;
                } catch (error) {
                    showSweetError({'message': error });
                    break;
                }



            default:
                return { message: 'ERROR' }
        }

    } catch (error) {
        showSweetError(error);
    }
}

/**
 * Show the modal with the error
 * @param error       // An object with the error message
 */
function showSweetError(error)
{
    console.log(error);
    customSweetAlert.fire({
        title: error.status ? 'Error status : ' + error.status : 'Error',
        confirmButtonText: 'Ok',
        text: error.data.message,
        icon: 'error',
    })
}

/**
 * Decide which sweetAlert modal should be displayed based on the action
 * @param configId       // An object with the error message
 * @param id             // The id of the resource to fetch
 * @param message        // The response sent by the back-end
 */
function showSweetConfirmation(configId = null, id = null, message = null)
{
    switch (true) {
        case action === 'delete' || action === 'send' || action === 'desactive' || action === 'reactive' || action === 'anonymise' || action === 'impersonate':
            customSweetAlert.fire({
                title: config[configId]['title'],
                showCancelButton: true,
                confirmButtonText: config[configId]['button']['text'],
                cancelButtonText: config[configId]['button']['cancel'],
                // I reversed the buttons as most people are right-handed & read from left-to-right,
                // so it seems more natural to confirm ("continue") the started action with the button on the right. --Dirk
                reverseButtons: true,
                html: config[configId]['content']['text'] + "<br><br><b>\"" + data + "\"</b>",
                icon: 'warning',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await proceedAction(configId, id);
                }
            })
            break;

        case action === 'done':
            customSweetAlert.fire(
                'Fait !', // TODO : Update with translations thing in config in each blade files
                configId ? message.data : 'Votre action a été réalisée avec succès !', // TODO : Update with translations thing in config in each blade files
                "success"
            ).then(async (result) => {
                window.location.reload();
            })
            break;

        case action === 'error':
            customSweetAlert.fire(
                'Error !',
                'An error occurred : ' + err.message,
                "error"
            ).then(async (result) => {
                window.location.reload();
            })
            break;

        default:
            return { message: 'ERROR' }
    }

}
